import { Directive, input, computed, inject } from "@angular/core";
import { JobsAndBillingCommonService } from "@shared/jobs-and-billing-common-service";
import type { IiFirmRole } from "@interfaces/index";
import { CardPanelType } from "@shared/interfaces";
import { IFirmRolesService } from "@shared/index";

@Directive()
export abstract class AssigneesPanel {
    protected readonly jobsAndBillingCommonService = inject(JobsAndBillingCommonService);
    protected readonly iFirmRolesService = inject(IFirmRolesService);

    protected readonly CardPanelType = CardPanelType;

    public type = input<CardPanelType>();

    protected readonly roles = computed(() => {
        const roles = this.iFirmRolesService.sIFirmRoles();
        return roles.sort(this.partnerFirstOrder());
    });

    protected readonly showRole = computed(() => {
        const settings = this.jobsAndBillingCommonService.currentSettings();
        const type = this.type();
        const roles = this.iFirmRolesService.sIFirmRoles();
        return (roleId: string): boolean => {
            const role = roles.find((r) => r.Id === roleId);
            if (!role) return false;
            switch (type) {
                case CardPanelType.Job:
                    if (!settings) return false;
                    return (role.IsManager && settings.jobManagerEnabled) || (role.IsPartner && settings.jobPartnerEnabled);
                case CardPanelType.Contact:
                    return role.IsManager || role.IsPartner;
                default:
                    return !role.IsManager && !role.IsPartner;
            }
        };
    });

    protected partnerFirstOrder(): (a: IiFirmRole, b: IiFirmRole) => number {
        return (a, b) => (a.IsPartner === b.IsPartner ? 0 : a.IsPartner ? -1 : 1);
    }
}
